import { useRestaurant } from '@local/do-secundo-restaurant-provider'
import { CooMenu } from '../types/menu'
import { ItemQuantityRuleView } from '../types/config'

export const useMenus = (): {
  menus?: CooMenu[]
  error: boolean
  loading: boolean
  menuItemQuantityRules: ItemQuantityRuleView[]
} => {
  const { ooConfig } = useRestaurant()

  const { menus, isError, isLoading } = useRestaurant()

  return {
    menus,
    error: isError,
    loading: isLoading,
    menuItemQuantityRules: ooConfig?.itemQuantityRules ?? []
  }
}
